import React, { useState, useEffect } from "react";
import { Row, Col, Tab, Tabs, Table } from "react-bootstrap";

import Pagamentos_online from "../Tesouraria/Pagamentos_online";
import Fidelizacao_serie_comparativa2 from "./fidelizacao_serie_comparativa2";
import Carteirinhas_tabelas from "./carteirinhas";
import Fidelizacao_serie_unidade from "./fidelizacao_serie_unidade";
import Alunos_novos_renovados_serie_rede from "./novos_renovados_serie_rede";

import { novos_renovados_total, fidelizacao } from "../../services/api";
import './tabelas_matricula.css'; // Importando o CSS padronizado

const Alunos_novos_renovados_bar = (props) => {
    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const meu_perfil = perfil[0].perfil;

    const [dataTotal, setDataTotal] = useState([]);
    const [dataPR27, setDataPR27] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    const dadosPR26 = [
        { "unidade": "01", "pr": 995 }, { "unidade": "02", "pr": 463 }, { "unidade": "03", "pr": 958 },
        { "unidade": "04", "pr": 1573 }, { "unidade": "05", "pr": 696 }, { "unidade": "06", "pr": 1091 },
        { "unidade": "09", "pr": 247 }, { "unidade": "10", "pr": 304 }, { "unidade": "11", "pr": 794 },
        { "unidade": "13", "pr": 329 }, { "unidade": "14", "pr": 1195 }, { "unidade": "15", "pr": 389 },
        { "unidade": "16", "pr": 909 }, { "unidade": "17", "pr": 762 }
    ];

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const responseT = await novos_renovados_total(data_inicio, data_fim);
            setDataTotal(responseT || []);
            const response4 = await fidelizacao(data_inicio, data_fim);
            setDataPR27(response4 || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    const dadosPR27 = dataPR27.map(item => ({ unidade: item.sec, pr: Number(item.pr) }));
    const busca_PR_Unidade = (array, targetUnidade) => {
        const result = array.find(item => item.unidade === targetUnidade);
        return result ? result.pr : 0;
    };

    // Variáveis Totalizadoras
    let tMat = { n27: 0, r27: 0, t27: 0, n26: 0, r26: 0, t26: 0 };
    let tAnd = { total27: 0, n27: 0, r27: 0, total27h: 0, n27h: 0, r27h: 0 };
    let tGes = { r27: 0, pr27: 0, r26: 0, pr26: 0 };

    // Processamento Único
    const processedData = dataTotal.map(item => {
        const uniNome = unidades[parseInt(item.unidade)] || `Unid. ${item.unidade}`;

        // Dados Matriculas
        const n27 = parseInt(item.n2027) || 0; const r27 = parseInt(item.r2027) || 0; const tot27 = parseInt(item.t2027) || 0;
        const n26 = parseInt(item.n2026) || 0; const r26 = parseInt(item.r2026) || 0; const tot26 = parseInt(item.t2026) || 0;
        tMat.n27 += n27; tMat.r27 += r27; tMat.t27 += tot27;
        tMat.n26 += n26; tMat.r26 += r26; tMat.t26 += tot26;

        // Dados Andamento
        const na27 = parseInt(item.na2027) || 0; const ra27 = parseInt(item.ra2027) || 0;
        const na27h = parseInt(item.na2027h) || 0; const ra27h = parseInt(item.ra2027h) || 0;
        tAnd.total27 += (na27 + ra27); tAnd.n27 += na27; tAnd.r27 += ra27;
        tAnd.total27h += (na27h + ra27h); tAnd.n27h += na27h; tAnd.r27h += ra27h;

        // Dados Gestor
        const pr27 = busca_PR_Unidade(dadosPR27, item.unidade);
        const pr26 = busca_PR_Unidade(dadosPR26, item.unidade);
        tGes.r27 += r27; tGes.pr27 += pr27;
        tGes.r26 += r26; tGes.pr26 += pr26;

        return {
            unidade: uniNome,
            mat: { n27, r27, tot27, n26, r26, tot26, ganhoN: (n26 ? ((n27 * 100) / n26) - 100 : 0), ganhoR: (r26 ? ((r27 * 100) / r26) - 100 : 0), ganhoT: (tot26 ? ((tot27 * 100) / tot26) - 100 : 0) },
            and: { tot27: na27 + ra27, n27: na27, r27: ra27, tot27h: na27h + ra27h, n27h: na27h, r27h: ra27h },
            ges: { r27, pr27, tx27: pr27 ? (r27 / pr27) * 100 : 0, r26, pr26, tx26: pr26 ? (r26 / pr26) * 100 : 0, variacao: (pr27 ? (r27 / pr27) * 100 : 0) - (pr26 ? (r26 / pr26) * 100 : 0) }
        };
    }).sort((a, b) => a.unidade.localeCompare(b.unidade));

    const getColorClass = (val) => val > 0 ? "text-positivo" : val < 0 ? "text-negativo" : "";

    const getVarClass = (value) => {
        if (value > 0) return "bg-green";
        if (value < 0) return "bg-red";
        return "";
    };

    return (
        <div className="Alunos_unidade_hist mt-4">
            <Row>
                <Col lg={12} sm={12}>
                    <Tabs defaultActiveKey="Total" id="uncontrolled-tab-example" className="mb-3">

                        {/* TAB MATRÍCULAS */}
                        <Tab eventKey="Total" title="Matriculas">
                            <h4 className="mb-3 fw-light text-secondary">Total de Matrículas</h4>
                            <div className="table-responsive shadow-sm rounded border">
                                <Table hover bordered className="text-center align-middle bg-white m-0 tabela-matriculas">
                                    <thead className="table-dark">
                                        <tr>
                                            <th className="text-start ps-3">UNIDADE</th>
                                            <th>N 27</th><th>R 27</th><th>T 27</th>
                                            <th>N 26</th><th>R 26</th><th>T 26</th>
                                            <th>Ganho N%</th><th>Ganho R%</th><th>Ganho T%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {processedData.map((row, idx) => (
                                            <tr key={idx}>
                                                <td className="text-start fw-bold bg-light ps-3">{row.unidade}</td>
                                                <td className="text-primary">{row.mat.n27}</td><td className="text-primary">{row.mat.r27}</td><td className="fw-bold text-primary">{row.mat.tot27}</td>
                                                <td className="text-danger">{row.mat.n26}</td><td className="text-danger">{row.mat.r26}</td><td className="fw-bold text-danger">{row.mat.tot26}</td>
                                                <td className={getVarClass(row.mat.ganhoN)}>{row.mat.ganhoN.toFixed(2)}%</td>
                                                <td className={getVarClass(row.mat.ganhoR)}>{row.mat.ganhoR.toFixed(2)}%</td>
                                                <td className={getVarClass(row.mat.ganhoT)}>{row.mat.ganhoT.toFixed(2)}%</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="fw-bolder border-top border-dark bg-light">
                                        <tr>
                                            <td className="text-start ps-3">SMREDE</td>
                                            <td className="text-primary">{tMat.n27}</td><td className="text-primary">{tMat.r27}</td><td className="text-primary">{tMat.t27}</td>
                                            <td className="text-danger">{tMat.n26}</td><td className="text-danger">{tMat.r26}</td><td className="text-danger">{tMat.t26}</td>
                                            <td className={getVarClass((tMat.n27 / tMat.n26 * 100) - 100)}>{((tMat.n27 / tMat.n26 * 100) - 100).toFixed(2)}%</td>
                                            <td className={getVarClass((tMat.r27 / tMat.r26 * 100) - 100)}>{((tMat.r27 / tMat.r26 * 100) - 100).toFixed(2)}%</td>
                                            <td className={getVarClass((tMat.t27 / tMat.t26 * 100) - 100)}>{((tMat.t27 / tMat.t26 * 100) - 100).toFixed(2)}%</td>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </div>
                        </Tab>

                        {/* TAB SÉRIE */}
                        <Tab eventKey="Serie" title="Mat. por Série">
                            <Alunos_novos_renovados_serie_rede di={data_inicio} df={data_fim} />
                        </Tab>

                        {/* TAB TAXA DE RENOVAÇÃO GESTOR */}
                        {(meu_perfil === "GESTOR" || (typeof meu_perfil === "string" && meu_perfil.startsWith("DIRETOR"))) && (
                            <Tab eventKey="Taxa" title="Taxa de Renovação">
                                <h4 className="mb-3 fw-light text-secondary">Taxa de Renovação</h4>
                                <Tabs className="mb-3">
                                    <Tab eventKey="Unidade" title="Por Unidade">
                                        <div className="table-responsive shadow-sm rounded border">
                                            <Table hover bordered className="text-center align-middle bg-white m-0 tabela-matriculas">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th className="text-start ps-3">UNIDADE</th>
                                                        <th>R 27</th><th>PR 27</th><th>R 27 %</th>
                                                        <th>R 26</th><th>PR 26</th><th>R 26 %</th>
                                                        <th>Variação</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {processedData.map((row, idx) => (
                                                        <tr key={idx}>
                                                            <td className="text-start fw-bold bg-light ps-3">{row.unidade}</td>
                                                            <td className="text-primary">{row.ges.r27}</td><td className="text-primary">{row.ges.pr27}</td><td className="fw-bold text-primary">{row.ges.tx27.toFixed(2)}%</td>
                                                            <td className="text-danger">{row.ges.r26}</td><td className="text-danger">{row.ges.pr26}</td><td className="fw-bold text-danger">{row.ges.tx26.toFixed(2)}%</td>
                                                            <td className={getVarClass(row.ges.variacao)}>{row.ges.variacao.toFixed(2)}%</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot className="fw-bolder border-top border-dark bg-light">
                                                    <tr>
                                                        <td className="text-start ps-3">SMREDE</td>
                                                        <td className="text-primary">{tGes.r27}</td><td className="text-primary">{tGes.pr27}</td><td className="fw-bold text-primary">{(tGes.r27 / tGes.pr27 * 100).toFixed(2)}%</td>
                                                        <td className="text-danger">{tGes.r26}</td><td className="text-danger">{tGes.pr26}</td><td className="fw-bold text-danger">{(tGes.r26 / tGes.pr26 * 100).toFixed(2)}%</td>
                                                        <td className={getVarClass((tGes.r27 / tGes.pr27 * 100) - (tGes.r26 / tGes.pr26 * 100))}>
                                                            {((tGes.r27 / tGes.pr27 * 100) - (tGes.r26 / tGes.pr26 * 100)).toFixed(2)}%
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="Serie" title="Por Série"><Fidelizacao_serie_comparativa2 di={data_inicio} df={data_fim} /></Tab>
                                    <Tab eventKey="Unidade2" title="Por Série e Unidade"><Fidelizacao_serie_unidade di={data_inicio} df={data_fim} /></Tab>
                                </Tabs>
                            </Tab>
                        )}

                        {/* TAB ANDAMENTO */}
                        {/* <Tab eventKey="Andamento" title="Matriculas em Andamento">
                            <h4 className="mb-3 fw-light text-secondary">Matrículas em Andamento</h4>
                            <div className="table-responsive shadow-sm rounded border">
                                <Table hover bordered className="text-center align-middle bg-white m-0 tabela-matriculas">
                                    <thead className="table-dark">
                                        <tr>
                                            <th className="text-start ps-3">UNIDADE</th>
                                            <th>TOTAL</th><th>NOVOS</th><th>RENOVADOS</th>
                                            <th>TOTAL HOJE</th><th>NOVOS HOJE</th><th>RENOVADOS HOJE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {processedData.map((row, idx) => (
                                            <tr key={idx}>
                                                <td className="text-start fw-bold bg-light ps-3">{row.unidade}</td>
                                                <td className="fw-bold">{row.and.tot27}</td><td>{row.and.n27}</td><td>{row.and.r27}</td>
                                                <td className="fw-bold">{row.and.tot27h}</td><td>{row.and.n27h}</td><td>{row.and.r27h}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="fw-bolder border-top border-dark bg-light">
                                        <tr>
                                            <td className="text-start ps-3">SMREDE</td>
                                            <td>{tAnd.total27}</td><td>{tAnd.n27}</td><td>{tAnd.r27}</td>
                                            <td>{tAnd.total27h}</td><td>{tAnd.n27h}</td><td>{tAnd.r27h}</td>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </div>
                        </Tab> */}

                        {/* OUTRAS TABS */}
                        {meu_perfil === "GESTOR" && (
                            <Tab eventKey="Pagamentos" title="Pagamentos Online">
                                <h4 className="mb-3 fw-light text-secondary">Pagamentos Online - Renovação</h4>
                                <Pagamentos_online />
                            </Tab>
                        )}
                        <Tab eventKey="Carteirinhas" title="Carteirinhas">
                            <Carteirinhas_tabelas di={data_inicio} df={data_fim} />
                        </Tab>

                    </Tabs>
                </Col>
            </Row>
        </div>
    );
};
export default Alunos_novos_renovados_bar;